import React, { Component } from 'react';
import './NotFound.css'

export default class NotFound extends Component {
    render(){
        return (
            <>
                <h2 className="not-found-h2">Page Not Found</h2>
            </>
        )
    }
}